import React from 'react';

/**
 * Reusable notes / comments textarea placed at the bottom of each wizard step.
 */
export default function NotesInput({ value, onChange }) {
  return (
    <div className="mt-4 pt-3 border-top">
      <label className="form-label text-muted small fw-semibold" htmlFor="step-notes">
        Notes / Comments <span className="fw-normal">(optional)</span>
      </label>
      <textarea
        id="step-notes"
        className="form-control"
        rows={4}
        placeholder="Add any clarifications or notes about the amounts entered above…"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
